import React, { useRef, useState } from 'react';
import './InstagramReels.css';
import { useReels } from '../hooks/useQueries';

const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const getYoutubeVideoId = (url) => {
  const match = url.match(/\/embed\/([^?]+)/);
  return match ? match[1] : null;
};

const ReelCard = ({ reel }) => {
  const handleClick = () => {
    window.open('https://www.youtube.com/watch?v=' + getYoutubeVideoId(reel?.videoUrl), '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`reel-card`}>
      <div className="reel-media">
        <iframe
          src={reel.videoUrl}
          className="reel-iframe"
          frameBorder="0"
          scrolling="no"
          allowTransparency="true"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          allowFullScreen
        />

        {/* Invisible overlay to block hover + redirect to YouTube on tap */}
        <div
          onClick={handleClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') handleClick();
          }}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
            cursor: "pointer",
          }}
        />
      </div>
    </div>
  );
};

const InstagramReels = ({ instagramUrl = 'https://www.instagram.com/f_creation09' }) => {
  const scrollRef = useRef(null);
  const { data: reels = [], isLoading: reelsLoading } = useReels();

  return (
    <section className="reels-section">
      <div className="container">

        <div className="reels-header">
          <div>
            <p className="section-label">Behind the scenes</p>
            <h2 className="section-title">Watch our reels</h2>
          </div>
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="reels-ig-btn"
          >
            <InstagramIcon />
            Follow on Instagram
          </a>
        </div>
        {(reelsLoading || reels.length > 0) && (
          <div className="reels-scroll" ref={scrollRef}>
            {reels.map((reel) => (
              <ReelCard key={reel.id} reel={reel} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default InstagramReels;